// Libs
import React from 'react';
import { Typography } from '@mui/material';

// Styles
import { useStyles } from './ApprovalShipmentMethodLabelStyles';

const ApprovalShipmentMethodLabel = ({
  approval,
  requestedMethod,
  approvedMethod,
  align = 'left',
  className,
  ...props
}) => {
  const { classes, cx } = useStyles({ align });

  const getLabelText = () => {
    if (!approval) {
      return 'Pending Approval';
    } else if (approval.is_auto_approval) {
      return `Auto-Approved By ${approval.approver}`;
    } else if (requestedMethod === approvedMethod) {
      return `Approved By ${approval.approver}`;
    } else return `Modified And Approved By ${approval.approver}`;
  };

  return (
    <Typography
      variant="textXs"
      color={'grey2'}
      className={cx(classes.label, className)}
      {...props}>
      {getLabelText()}
    </Typography>
  );
};

export default ApprovalShipmentMethodLabel;
